import { Box } from "@mui/material";

function SecondStep() {
return(
  <>
  <h1 className="text-[color:--primary-color] text-center uppercase font-extrabold text-2xl pb-6">documentações do coworking</h1>
  {/* TORNAR OPCIONAL */}
  <Box className="w-96 m-auto flex flex-col justify-center items-center my-1 lg:my-3"
    sx={{ '& > :not(style)': { m: 1 } }}
    component="form"
    noValidate
    autoComplete="off">
      <div className="xl:col-start-2">
      <p className="self-start mt-10">Alvará de Funcionamento</p>
      <button className="bg-[#f4f4f4] my-4 text-xs font-semibold py-1 border-2 border-dotted border-[color:--secondary-color] rounded-lg w-64 text-[color:--secondary-color]">Exportar arquivo</button>

      <p className="self-start mt-10">Atestado de vitoria dos bombeiros</p>
      <button className="bg-[#f4f4f4] my-4 text-xs font-semibold py-1 border-2 border-dotted border-[color:--secondary-color] rounded-lg w-64 text-[color:--secondary-color]">Exportar arquivo</button>

      <p className="self-start mt-10">Cartão de Inscrição Municipal</p>
      <button className="bg-[#f4f4f4] my-4 text-xs font-semibold py-1 border-2 border-dotted border-[color:--secondary-color] rounded-lg w-64 text-[color:--secondary-color]">Exportar arquivo</button>

      <p className="self-start mt-10">Ficha do Imóvel</p>
      <button className="bg-[#f4f4f4] my-4 text-xs font-semibold py-1 border-2 border-dotted border-[color:--secondary-color] rounded-lg w-64 text-[color:--secondary-color]">Exportar arquivo</button>
      </div>

  </Box></>
)
}

export default SecondStep;